/* ==========================================================================
   PICK, DON'T TYPE

   Two number fields is a small ask on paper and a large one in practice. The
   customer has to find a tape measure, trust their own reading, type it, and
   then wonder whether they got it wrong. Most people just leave.

   So step 2 leads with the ranges we actually make, as buttons, built live from
   the catalog for whichever furniture they picked. Choosing "58 to 67 inches"
   is a recognition task; typing 63.5 is a recall task, and recognition wins
   every time, particularly for anyone who is not sure what "inner width" means
   yet.

   WHAT CHANGED AND WHY IT MATTERS:
   This file used to find the number fields with el.closest('.frow') and insert
   itself above them. There is no .frow in the markup, the lookup returned
   nothing, and the panel fell to the bottom of the step while the number fields
   stayed visible. Every visitor got the ranges, the instructions, the diagram
   and two empty boxes at once, in the wrong order. The panel now renders into
   an explicit #pickmount that Liquid prints in the right place, so there is
   nothing to guess at. If the chips ever vanish, check that #pickmount exists.

   The list of ranges a tile may offer is NOT decided here. It comes from
   poolFor() in size-logic.js, which is the same function the matcher uses. That
   is deliberate: when the chips and the matcher each had their own idea of what
   a "Sofa" is, a customer could press a range and be told he had picked the
   wrong furniture. One source, one answer.

   Typing stays available under the "Not sure?" disclosure below, which is
   plain HTML and needs no JavaScript to open.
   ========================================================================== */
(function(){
  function ready(fn){
    if(document.readyState === 'complete') fn();
    else window.addEventListener('load', fn);
  }

  ready(function(){
    var mount = document.getElementById('pickmount');
    if(!mount || typeof CATALOG === 'undefined') return;

    var wEl  = document.getElementById('w');
    var dEl  = document.getElementById('d');
    var cEl  = document.getElementById('c');
    var calc = document.getElementById('calc');
    if(!wEl || !dEl || !calc) return;

    var chosen = {band:null, depth:null, chaise:null};

    /* Single source of truth, shared with the matcher. The fallback only fires
       if size-logic.js failed to load, in which case the chips are the least of
       our problems, but a broken step 2 is worse than a narrow one. */
    function poolOf(type){
      if(typeof poolFor === 'function') return poolFor(type);
      return CATALOG.filter(function(p){
        return type === 'sectional' ? p.type === 'sectional' : p.type === type;
      });
    }

    function bandsFor(type){
      var seen = {}, out = [];
      poolOf(type).forEach(function(p){
        var k = p.min + '-' + p.max;
        if(!seen[k]){ seen[k] = 1; out.push({min:p.min, max:p.max}); }
      });
      return out.sort(function(a,b){ return a.min - b.min; });
    }

    function depthsFor(type, band){
      var seen = {}, out = [];
      poolOf(type).forEach(function(p){
        if(band && (p.min !== band.min || p.max !== band.max)) return;
        if(!seen[p.depth]){ seen[p.depth] = 1; out.push(p.depth); }
      });
      return out.sort(function(a,b){ return a - b; });
    }

    /* Somebody who answered with the buttons never typed a chaise length, so we
       fill in the middle of the range the set covers. It is inside the range by
       definition, which is what the matcher needs to hand back the set rather
       than asking for a third number the customer was never shown a box for.
       The old code read a single p.chaise here. That field is gone, and reading
       it now would leave the field empty and stop every sectional at step 2
       with an error about a measurement nobody asked for. */
    function chaiseMidpoint(band){
      var sets = CATALOG.filter(function(p){
        if(p.type !== 'sectional') return false;
        return !band || (p.min === band.min && p.max === band.max);
      });
      for(var i = 0; i < sets.length; i++){
        var lo = sets[i].chaiseMin != null ? sets[i].chaiseMin : sets[i].chaise;
        var hi = sets[i].chaiseMax != null ? sets[i].chaiseMax : sets[i].chaise;
        if(lo != null && hi != null) return (lo + hi) / 2;
      }
      return null;
    }

    function chip(label, sub, on){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pick' + (on ? ' on' : '');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.innerHTML = '<b>' + label + '</b>' + (sub ? '<small>' + sub + '</small>' : '');
      return b;
    }

    function submit(){
      if(!chosen.band || chosen.depth == null) return;
      // Midpoint of the chosen band: it sits inside the range by definition, so
      // the matcher returns that exact product rather than a near miss.
      wEl.value = ((chosen.band.min + chosen.band.max) / 2).toFixed(1);
      dEl.value = chosen.depth;
      if(cEl && chosen.chaise != null) cEl.value = chosen.chaise;
      calc.click();
    }

    function build(){
      var type = (typeof sel !== 'undefined' && sel.type) ? sel.type : null;
      if(!type) return;
      chosen = {band:null, depth:null, chaise:null};
      mount.innerHTML = '';

      var isSec = type === 'sectional';

      var h1 = document.createElement('h4');
      h1.className = 'pickhead';
      h1.textContent = isSec ? 'How wide is the long run?' : 'How wide is the seat, arm to arm?';
      mount.appendChild(h1);

      var hint = document.createElement('p');
      hint.className = 'pickhint';
      hint.textContent = 'Cushions off. Pick the range your seat falls into. If you are between two, the smaller one is the safe choice.';
      mount.appendChild(hint);

      var wRow = document.createElement('div');
      wRow.className = 'pickrow';
      mount.appendChild(wRow);

      var dHead = document.createElement('h4');
      dHead.className = 'pickhead';
      dHead.textContent = 'And how deep is it, front to back?';
      var dRow = document.createElement('div');
      dRow.className = 'pickrow';
      dHead.hidden = true; dRow.hidden = true;
      mount.appendChild(dHead); mount.appendChild(dRow);

      bandsFor(type).forEach(function(band){
        var b = chip(band.min + '" to ' + band.max + '"', 'inches wide');
        b.addEventListener('click', function(){
          chosen.band = band; chosen.depth = null;
          wRow.querySelectorAll('.pick').forEach(function(x){
            x.classList.remove('on'); x.setAttribute('aria-pressed','false');
          });
          b.classList.add('on'); b.setAttribute('aria-pressed','true');

          dRow.innerHTML = '';
          var depths = depthsFor(type, band);

          /* ONE DEPTH IS NOT A QUESTION.

             Some widths are only made in a single depth. A recliner is the
             clearest case: whichever width you press, there is exactly one
             board behind it. The old code still drew the depth heading and a
             lone button and waited for somebody to press it, which asked the
             customer to confirm an answer we already had. A step with one
             possible outcome adds nothing and can still be abandoned.

             Nothing about the match changes. submit() writes the same depth
             the single button would have written, so the result card is the
             one that extra click used to produce, and the depth is printed on
             that card, so nobody is handed a number they were never shown.

             Written as a count rather than a furniture type on purpose: it is
             the catalog that decides, so adding a second recliner depth turns
             the step back on by itself, with no code change. */
          if(depths.length === 1){
            chosen.depth = depths[0];
            if(isSec) chosen.chaise = chaiseMidpoint(band);
            dHead.hidden = true; dRow.hidden = true;
            setTimeout(submit, 160);
            return;
          }

          /* No depths at all should be impossible, since the band came out of
             the same pool. If the data ever contradicts itself, stop here
             rather than dropping the visitor into an empty step. */
          if(!depths.length){ dHead.hidden = true; dRow.hidden = true; return; }

          depths.forEach(function(depth){
            var d = chip(depth + '"', 'deep');
            d.addEventListener('click', function(){
              chosen.depth = depth;
              dRow.querySelectorAll('.pick').forEach(function(x){
                x.classList.remove('on'); x.setAttribute('aria-pressed','false');
              });
              d.classList.add('on'); d.setAttribute('aria-pressed','true');
              if(isSec) chosen.chaise = chaiseMidpoint(band);
              setTimeout(submit, 160);
            });
            dRow.appendChild(d);
          });
          dHead.hidden = false; dRow.hidden = false;
          dHead.scrollIntoView({block:'nearest', behavior:'smooth'});
        });
        wRow.appendChild(b);
      });
    }

    document.querySelectorAll('.type').forEach(function(b){
      b.addEventListener('click', function(){ setTimeout(build, 180); });
    });
    if(typeof sel !== 'undefined' && sel.type) build();
  });
})();
